<template>
  <section id="Blacklists" class="section-item">
    <h1>{{ $t("title.blacklists") }}</h1>

    <section id="api-Blacklists-PutBlacklistId">
      <h2>{{ $t("title.update_expiration") }}</h2>
      <p>
        {{ $t("blacklists.update_blacklist_expiration_method") }}
      </p>
      <div class="">
        <div class="put type">PUT</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/blacklist/:id</code></pre>
      </div>
      <div class="code-toggle">
        <button class="json">JSON</button>
      </div>

      <pre>
              <code class="language-json">{
  "expired_at": "2020-10-07 21:53"
}</code>
            </pre>

      <h3>{{ $t("general.field") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.blacklist_id") }}</td>
          </tr>
          <tr>
            <td>expired_at</td>
            <td>String</td>
            <td>{{ $t("table.new_blacklist_expiration_date_time") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Blacklists-PostBlacklist">
      <h2>{{ $t("title.create_blacklist") }}</h2>
      <p>{{ $t("blacklists.create_blacklist_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/blacklist</code></pre>
      </div>
      <div class="code-toggle">
        <button class="json">JSON</button>
      </div>

      <pre>
              <code class="language-json">{
  "numbers": "(38)99962-8692",
  "expired_at": "2020-11-07 20:25"
}</code></pre>

      <h3>{{ $t("general.field") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>numbers</td>
            <td>String</td>
            <td>{{ $t("table.blacklist_number") }}</td>
          </tr>
          <tr>
            <td>expired_at</td>
            <td>String</td>
            <td>{{ $t("table.blacklist_end_date_time") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Blacklists-DeleteBlacklist">
      <h2>{{ $t("title.delete_blacklists") }}</h2>
      <p>
        {{ $t("blacklists.delete_blacklists_by_ids_method") }}
      </p>
      <div class="">
        <div class="delete type">DELETE</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/blacklist</code></pre>
      </div>

      <div class="code-toggle">
        <button class="json">JSON</button>
      </div>
      <pre>
              <code class="language-json">{
  "ids": ["5e733886-dde4-4a7a-9d93-30d29b4f88dc", "d817048f-3afc-40be-a14e-1761b4ff84ef"]
}</code>
            </pre>

      <h3>{{ $t("general.field") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ids</td>
            <td>Array</td>
            <td>{{ $t("table.blacklist_ids_to_delete") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Blacklists-DeleteBlacklistId">
      <h2>{{ $t("title.delete_by_id") }}</h2>
      <p>{{ $t("blacklists.delete_blacklist_by_id_method") }}</p>
      <div class="">
        <div class="delete type">DELETE</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/blacklist/:id</code></pre>
      </div>

      <h3>{{ $t("general.field") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.blacklist_id") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Blacklists-GetBlacklist">
      <h2>{{ $t("title.blacklists") }} -</h2>
      <p>{{ $t("blacklists.list_blacklists_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/blacklist</code></pre>
      </div>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "BlacklistsComponent",
  data() {
    return {
      selectedTab: "json",
      selectedTabCreate: "json-wpp",
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
    selectedTabCreate() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
